/**
 * Logique pure du menu d'en-tête : combien de liens tiennent sur la ligne, et
 * où se pose la rangée selon le style de menu.
 *
 * Le menu ne passe plus à la ligne. Il le faisait mal : le groupe de liens
 * étant un seul item flex, le navigateur cassait la ligne **avant** lui et
 * envoyait tous les liens sous le logo, laissant le logo seul sur sa ligne. Ce
 * qui déborde part maintenant dans un menu « Plus ».
 */

/** L'alignement de la rangée de liens selon le style de menu. */
export function navRowJustify(navVariant) {
  if (navVariant === 'centered') return 'center';
  if (navVariant === 'split') return 'flex-start';
  return 'flex-end';
}

/**
 * Combien de liens tiennent sur la ligne.
 *
 * Si tout tient, on renvoie la liste entière : pas de bouton « Plus » quand il
 * n'y a rien dedans. Sinon on réserve sa place, puis on compte. **Au moins un
 * lien reste visible** même quand il ne tient pas : une barre réduite à
 * « Plus » ne dit plus rien de ce qu'il y a dans le site.
 */
export function countVisibleLinks(itemWidths = [], { gap = 0, moreWidth = 0, available = 0 } = {}) {
  if (!itemWidths.length) return 0;

  const widthOf = (count) => itemWidths
    .slice(0, count)
    .reduce((total, width, index) => total + width + (index ? gap : 0), 0);

  if (widthOf(itemWidths.length) <= available) return itemWidths.length;

  const room = available - moreWidth - gap;
  let visible = 0;
  while (visible < itemWidths.length && widthOf(visible + 1) <= room) visible += 1;
  return Math.max(1, visible);
}

/** Le partage visible / débordé, une fois le compte connu. L'ordre est gardé. */
export function splitOverflowLinks(links = [], visibleCount = 0) {
  if (visibleCount >= links.length) return { visible: links, overflow: [] };
  return {
    visible: links.slice(0, Math.max(0, visibleCount)),
    overflow: links.slice(Math.max(0, visibleCount)),
  };
}

/**
 * Les liens visibles coupés en deux moitiés autour du logo (style « répartis »).
 *
 * Le débordement se calcule sur la liste entière avant la coupe : mesurer deux
 * demi-rangées séparément ferait dépendre le résultat de l'endroit où tombe la
 * coupe, qui dépend lui-même du résultat.
 */
export function splitAroundLogo(visible = []) {
  const half = Math.ceil(visible.length / 2);
  return { left: visible.slice(0, half), right: visible.slice(half) };
}
